import React, {useMemo, useRef} from 'react';

import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {ListItem as DefaultListItem} from "./list-item";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {BaseStyle} from "../../../../infrastructure/models/base-style";
import classNames from "classnames";
import styles from "./list.module.scss";
import {ScrollerWrapper} from "../../scroll-wrapper/scroll-wrapper";

export class ListProps extends BaseProps {
  className: String;
  itemClassName: String;
  items: Array<BaseViewModel>;
  ListItemElement: React.Component;
  listItemProps: BaseProps;
  listItemStyle: BaseStyle;
  itemPropName: String;
  microDataName: String;
  onChange: Function;
  shouldUseScrollbar: Boolean;
  suppressScroll: Boolean;
}

export const List = ({style, itemScope, itemType, className, itemClassName, listItemProps, listItemStyle, items, onChange, microDataName, shouldUseScrollbar, itemPropName, ListItem = DefaultListItem, suppressScroll = false}: ListProps) => {
  const inViewRef = useRef();

  const containerProps = {
    style: style,
    className: classNames(styles.container, className),
    itemScope: itemScope,
    itemType: itemType
  };

  const itemsElements = useMemo(() => {
    return items?.map((item: BaseViewModel, index: Number) => {
      const listItemObject = {
        className: itemClassName,
        key: item.key || item.id || index,
        ...(listItemProps || {}),
        style: listItemStyle || {},
        [itemPropName || 'item']: item,
        isFirst: index === 0,
        isLast: index === items.length - 1,
        index,
        onChange: (item) => onChange(item),
        inViewRef,
      };

      return listItemObject;
    })
  }, [items, listItemProps]);

  return (shouldUseScrollbar ?
      <ScrollerWrapper {...containerProps} suppressScrollX={suppressScroll}>
        {
          microDataName ? <meta itemProp="name" content={microDataName}/> : null
        }
        {
          itemsElements?.map((itemProps) => {
            const {key, ...rest} = itemProps;

            return <ListItem {...rest} key={key}/>
          })
        }
      </ScrollerWrapper> : <div {...containerProps}>
        {
          microDataName ? <meta itemProp="name" content={microDataName}/> : null
        }
        {
          itemsElements?.map((itemProps) => {
            const {key, ...rest} = itemProps;

            return <ListItem {...rest} key={key}/>
          })
        }
      </div>
  )
};
